import React from 'react';
import {Grid,Grow,Typography} from '@material-ui/core'; // to make mobile friendly, nice text and animations

import useStyles from './styles.js';
import NewsCard from '../NewsCard/NewsCard';

const infoCards = [
  { color: '#00838f', title: 'Latest News', text: 'Give me the latest news' },
  { color: '#1565c0', title: 'News by Categories', info: 'Entertainment, Science,Technology...', text: 'Give me the latest Technology news' },
  { color: '#4527a0', title: 'News by Terms', info: 'Bitcoin, PlayStation 5, Smartphones,...', text: 'What\'s up with PlayStation 5' },
  { color: '#283593', title: 'News by Sources', info: 'CNN, BBC News, Time, IGN News...', text: 'Give me the news from CNN ' },
  { color: '#063577', title: 'Weather', text: 'Try saying: What is the weather in Lucknow , Is it raining' },
  { color: '#223399', title: 'Calculator', text: ' What is 3+1, Calculate 2 cubed' },
  { color: '#0083aa', title: 'Calender', text: ' What is the current date,  What is the current time,  What day will be next year' },
  { color: '#6c79e4', title: 'SmallTalk', text: 'Try saying: Hello, How are you, You are slow, Who devloped you' },
];

//article for artical, i for artical number
const NewsCards=({articles,activeArticle})=>{
	const classes=useStyles();

	if(!articles.length){
		return(
			<Grow in>
		    <Grid className={classes.container} container alingnItems="stretch" spacing={3}>
		    	{infoCards.map((infoCard)=>(
		    			<Grid item xs={12} sm={6} md={4} lg={3} className={classes.infoCard} >
		    				<div className={classes.card} style={{backgroundColor:infoCard.color}}>
		    					<Typography variant="h5">{infoCard.title}</Typography>
		    					{infoCard.info ? (<Typography variant="h6"><strong>{infoCard.title.split(" ")[2]}:</strong> <br />{infoCard.info}</Typography>):null}
		    				<Typography variant="h6">Try saying:<br /><i>{infoCard.text}</i></Typography>
		    				</div>
		    			</Grid>
		    		))}
		    </Grid>

			</Grow>
			);
	}


	return(
		<Grow in>
		    <Grid className={classes.container} container alingnItems="stretch" spacing={3}>



		    
		    {articles.map((article,i)=>(      //mapping bz article is an array
		    <Grid item xs={12} sm={6} md={4} lg={3} style={{display:"flex"}}>
		    	<NewsCard article={article} activeArticle={activeArticle} i={i}  /> 
		    </Grid> 
		    	))}
		    </Grid>

		</Grow>
		);
} 

export default NewsCards;